<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="mx-1"
          v-bind="attrs"
          v-on="on"
          :color="color"
          :min-width="minWidth"
          :outlined="outlined"
          :rounded="rounded"
          :disabled="disabled"
          :text="text"
          :x-small="xsmall"
          :small="small"
          :large="large"
          :x-large="xlarge"
          :style="outlined ? 'border-width:2px;background-color:#FFFFFF;' : ''"
          @click="onRirekiButtonClick">
          <v-icon v-if="prependIcon" class="ml-1">{{ prependIcon }}</v-icon>
          履歴検索
          <v-icon v-if="appendIcon" class="ml-1">{{ appendIcon }}</v-icon>
        </v-btn>
      </template>
      <!-- RAW形式で文字列展開 -->
      <span v-html="message"></span>
    </v-tooltip>
    <v-dialog max-width="90%" min-height="85vh" scrollable persistent no-click-animation v-bind="computedProps" v-on="computedListeners" v-model="showDialog">
      <v-card>
        <v-toolbar elevation="2" color="#2F75B5" dark dense>
          <v-spacer/>
          <v-toolbar-title>
            受注履歴検索
          </v-toolbar-title>
          <v-spacer/>
          <v-btn @click="onCloseClick" text>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid class="px-2 base-area">
            <!-- **************************************************************************************************** --
              -- 検索条件
              -- **************************************************************************************************** -->
            <div class="pa-2">
              <v-row no-gutters justify="start" ref="_calcHeight-Row1">
                <dd-sub-header>
                  <span>以下の検索条件で絞り込む</span>
                  <span style="float: right;">
                    <dd-transparent-button :minWidth="140" @click="isConditionHide = !isConditionHide">
                    <div v-if="!isConditionHide" class="condition-expansion">検索条件を閉じる<v-icon>mdi-chevron-up</v-icon></div>
                    <div v-else class="condition-expansion">検索条件を開く<v-icon>mdi-chevron-down</v-icon></div>
                    </dd-transparent-button>
                  </span>
                </dd-sub-header>
              </v-row>
              <div v-if="!isConditionHide" class="px-1 pt-0 pb-2 condition-area">
                <v-row no-gutters ref="_calcHeight-Row2">
                  <v-col :cols="12">
                    <span class="ml-1 view-description">登録済み受注を検索したい条件を入力して[検索をする]を押下してください。</span>
                  </v-col>
                </v-row>
                <v-row no-gutters ref="_calcHeight-Row2">
                  <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="8" class="px-1">
                    <dd-code-text-box
                      label="受注営業所"
                      v-model="conditions.juchuEigyoshoId"
                      ref="juchuEigyoshoId"
                      :length="100"
                      :required="false"
                      :valueType="Ctrls.InputTypes.Free"
                      titleText="営業所マスタ検索"
                      :headerList="mstEigyoshoHeaders"
                      item-value="eigyoshoCd"
                      item-text="eigyoshoNm"
                      returnValueName="id"
                      :searchColumns="['eigyoshoCd', 'eigyoshoNm', 'eigyoshoNmKana']"
                      :itemList="filteredEigyoshoList"
                      tooltipText="検索したい営業所を入力しましょう。<br>未入力の場合は全営業所が対象になります。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      />
                  </v-col>
                </v-row>
                <v-row no-gutters ref="_calcHeight-Row3">
                  <v-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3" :cols="12" class="px-1" v-if="!abbreviatedDisplay">
                    <dd-date-range-box
                      label="配送日"
                      :required="true"
                      :fromDate.sync="conditions.sagyoYoteiStartYmdString"
                      :toDate.sync="conditions.sagyoYoteiEndYmdString"
                      tooltipText="必須項目です。<br>指定した範囲の日付の配送明細が対象となります。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                    />
                  </v-col>
                  <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="9" class="px-1" v-if="abbreviatedDisplay">
                    <dd-date-box
                      label="配送日From"
                      v-model="conditions.sagyoYoteiStartYmdString"
                      ref="sagyoYoteiStartYmdString"
                      :required="true"
                      max="2999/12/31"
                      min="2000/01/01"
                      tooltipText="必須項目です。<br>指定した範囲の日付の配送明細が対象となります。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                    />
                  </v-col>
                  <v-col :cols="1" class="px-1 pt-6" v-if="abbreviatedDisplay">
                    <span>～</span>
                  </v-col>
                  <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="9" class="px-1" v-if="abbreviatedDisplay">
                    <dd-date-box
                      label="配送日To"
                      v-model="conditions.sagyoYoteiEndYmdString"
                      ref="sagyoYoteiEndYmdString"
                      :required="true"
                      max="2999/12/31"
                      min="2000/01/01"
                      tooltipText="必須項目です。<br>指定した範囲の日付の配送明細が対象となります。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                    />
                  </v-col>
                  <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="12" class="px-1">
                    <dd-code-text-box
                      label="荷主"
                      v-model="conditions.tokuisakiId"
                      ref="tokuisakiId"
                      :length="100"
                      :required="false"
                      :valueType="Ctrls.InputTypes.Free"
                      titleText="取引先マスタ検索"
                      :headerList="mstTorihikisakiHeaders"
                      item-value="torihikisakiCd"
                      item-text="torihikisakiNm"
                      returnValueName="id"
                      :searchColumns="['torihikisakiCd', 'torihikisakiNm', 'torihikisakiNmKana']"
                      :itemList="filteredMstTokuisakiList"
                      tooltipText="検索したい得意先を入力しましょう。<br>未入力の場合は全得意先が対象になります。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                    />
                  </v-col>
                  <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1" v-if="viewStyleType !== 1">
                    <dd-text-box
                      label="注文番号"
                      v-model="conditions.chumonNo"
                      ref="chumonNo"
                      :length="20"
                      :valueType="Ctrls.InputTypes.Free"
                      tooltipText="検索したい注文番号を入力しましょう"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      />
                  </v-col>
                </v-row>

                <v-row no-gutters ref="_calcHeight-Row4" v-if="viewStyleType !== 1">
                  <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1">
                    <dd-text-box
                      label="発地"
                      v-model="conditions.hatsuchiNm"
                      ref="hatsuchiNm"
                      :valueType="Ctrls.InputTypes.Free"
                      :length="100"
                      tooltipText="検索したい発地を入力しましょう。<br>未入力の場合は全発地が対象になります。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                    />
                  </v-col>
                  <v-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1">
                    <dd-text-box
                      label="着地"
                      v-model="conditions.chakuchiNm"
                      ref="chakuchiNm"
                      :length="100"
                      :valueType="Ctrls.InputTypes.Free"
                      tooltipText="検索したい着地を入力しましょう。<br>未入力の場合は全着地が対象になります。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                    />
                  </v-col>
                  <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1">
                    <dd-text-box
                      label="商品"
                      v-model="conditions.hinmeiNm"
                      ref="hinmeiNm"
                      :length="100"
                      :valueType="Ctrls.InputTypes.Free"
                      tooltipText="検索したい商品を入力しましょう。<br>未入力の場合は全商品が対象になります。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-2" no-gutters justify="center" ref="_calcHeight-Row5">
                  <dd-custom-button
                    :rounded="true"
                    :minWidth="200"
                    :large="true"
                    :tooltipText="`入力された検索条件で登録済みの受注を検索します`"
                    :enableToolTip="helpUseFlg"
                    :tooltipBottom="true"
                    @click="onSearchButtonClick">
                    検索をする
                  </dd-custom-button>
                  <a
                    class="condition-clear"
                    @click="onClearButtonClick">
                    条件をクリア
                  </a>
                </v-row>
              </div>
            </div>

            <div class="px-1 py-2" v-if="filteredRows.length > 0">
              <v-row no-gutters>
                <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="5" class="px-1">
                  <span class="search-number">{{ computedTotalItems  }}</span>件 の検索結果
                </v-col>
                <v-col :xs="7" :sm="7" :md="7" :lg="4" :xl="4" :cols="7" v-if="!abbreviatedDisplay">
                  <a
                    class="condition-clear-bottom"
                    @click="onClearButtonClick">
                    条件をクリア
                  </a>
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="mt-2" v-if="!abbreviatedDisplay">
                  <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="px-1">
                  <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
                </v-col>
              </v-row>

              <hr class="section-line mb-2">

              <v-row no-gutters justify="end"  v-if="!abbreviatedDisplay">
                <v-col :cols="6" class="d-sm-block" />
                <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12">
                  <v-row no-gutters justify="end">
                    <dd-select-items-per-page
                      ref="pagination1"
                      :itemsPerPage.sync="itemsPerPage"
                      :currentPage.sync="page"
                      :items="filteredRows"
                      @changeItemsPerPage="changeItemsPerPage"
                      @changePage="changePage"
                    />
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-data-table
                  item-key="id"
                  :headers="headers"
                  :items="filteredRows"
                  :custom-filter="filtering"
                  :search="searchText"
                  :items-per-page="itemsPerPage"
                  :page.sync="page"
                  @dblclick:row="onRowDoubleClick"
                  no-data-text="対象データはありません"
                  fixed-header
                  :hide-default-header="abbreviatedDisplay"
                  hide-default-footer
                  locale="ja-jp"
                  dense
                >
                  <template v-slot:[`item.actions`]="{item}">
                    <template>
                      <v-chip
                        small
                        color="primary"
                        @click="onRowSelectButtonClick(item)"
                      >
                        選択
                      </v-chip>
                    </template>
                  </template>
                  <template v-if="$scopedSlots.body" v-slot:body="slotProps">
                    <slot name="body" :displayItems="computedDisplayItems" :headers="slotProps.headers" :selectRow="onRowSelectButtonClick">
                      <tbody>
                        <tr
                          v-for="(row, rowIndex) in computedDisplayItems"
                          :key="getRowKey(row, rowIndex)"
                        >
                          <td v-for="h in slotProps.headers" :key="h.value">
                            {{ row[h.value] }}
                          </td>
                        </tr>
                      </tbody>
                    </slot>
                  </template>
                </v-data-table>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters class="px-1 py-0 mt-3">
            <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12">
              <dd-transparent-button :minWidth="120" @click="onCloseClick">
                <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
              </dd-transparent-button>
            </v-col>
            <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12" v-if="filteredRows.length > 0 && !abbreviatedDisplay" >
              <v-row no-gutters justify="end">
                <dd-select-items-per-page
                  ref="pagination2"
                  :itemsPerPage.sync="itemsPerPage"
                  :currentPage.sync="page"
                  :items="filteredRows"
                  @changeItemsPerPage="changeItemsPerPage"
                  @changePage="changePage"
                />
              </v-row>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
/**
 * @file DDv2用ツールチップ付きアイコンボタン
 * @namespace components
 */

/**
 * @vue-prop {String} [message=''] - ツールチップメッセージ
 * @vue-prop {String} [icon=''] - アイコン指定
 * @vue-event {Element} click - クリックイベント
 * @see https://vuetifyjs.com/ja/api/v-icon/
 * @see https://vuetifyjs.com/ja/api/v-tooltip/
 * @description message引数はRAW形式で、タグの挿入を許可しているため、指定する際は注意すること
 * @example
 *   <dd-icon-button-with-tooltip
        v-if="item.delFlg == false"
        message="この行のコピーを作成します"
        icon="mdi-content-copy"
        @click="copyMeisaiRow(item)"/>
 */
import flowMixin from '@/mixins/flowMixins'
import controls from '@/rahmen/controls'
import date from '@/ddv2.library/date'
import modals from '@/ddv2.library/modals'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import { mapGetters } from 'vuex'
import validators from '@/rahmen/validators'

import DdCustomButton from '@/components/DdCustomButton'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdTextBox = () => import('@/components/DdTextBox')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  mixins: [flowMixin],
  name: 'DdJuchuRirekiSearchButton',
  components: {
    DdCustomButton,
    DdDateBox,
    DdDateRangeBox,
    DdTransparentButton,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdCodeTextBox,
    DdSubHeader,
    DdTextBox
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    paramCondition: Object,
    color: {
      type: String,
      default: 'primary'
    },
    minWidth: {
      type: Number,
      default: 80
    },
    outlined: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    text: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: 'mdi-cloud-search'
    },
    /**
     * ボタンサイズ
     */
    xsmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xlarge: {
      type: Boolean,
      default: false
    },
    customHeaders: Array,
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 100
    }
  },
  data: () => ({
    conditions: {},
    // フィルター定義 －－ここまで－－
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    isConditionHide: false,
    showDialog: false,
    rows: [],
    loading: false,
    // 一覧制御用
    selected: [],
    page: 1
    /*
     *
     */
  }),
  created () {
    console.log('screen created')
    this.mstEigyoshoHeaders = header.mstEigyoshoHeaders
    this.mstTorihikisakiHeaders = header.mstTorihikisakiHeaders
    this.mstHacchakuchiHeaders = header.mstHacchakuchiHeaders
    this.mstHinmeiHeaders = header.mstHinmeiHeaders
  },
  mounted () {
    this.initialize()
  },
  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
        if ((this.paramCondition) && ![undefined, null, ''].includes(this.paramCondition.tokuisakiId)) {
          this.onSearchButtonClick()
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userSettings: 'DDMasters/mstUserSettings',
      helpUseFlg: 'users/helpUseFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    viewStyleType () {
      const type = this.abbreviatedDisplay || [undefined, null].includes(this.userSettings) || [undefined, null].includes(this.userSettings.useNippoEditType) ? 1 : this.userSettings.useNippoEditType
      return type
    },
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 品名マスタフィルター --> ここから
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 品名マスタフィルター <-- ここまで
    filteredRows () {
      const self = this
      return self.rows.map((elem) => {
        elem.juchuEigyoshoDisp = elem.juchuEigyoshoCd ? elem.juchuEigyoshoNm : ''
        elem.sagyoYoteiYmdDisp = elem.sagyoYoteiYmd ? filter.dateFormatter(elem.sagyoYoteiYmd) : ''
        elem.tokuisakiDisp = elem.tokuisakiCd ? elem.tokuisakiNm : ''
        elem.unchinKakuteiFlgDisp = elem.unchinKakuteiFlg ? '〇' : ''
        elem.seikyuTomeFlgDisp = elem.seikyuTomeFlg ? '〇' : ''
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.keiyuchi1Disp = elem.keiyuchi1Cd ? elem.keiyuchi1Cd + ' : ' + elem.keiyuchi1Nm : elem.keiyuchiBiko1
        elem.keiyuchi2Disp = elem.keiyuchi2Cd ? elem.keiyuchi2Cd + ' : ' + elem.keiyuchi2Nm : elem.keiyuchiBiko2
        elem.keiyuchi3Disp = elem.keiyuchi3Cd ? elem.keiyuchi3Cd + ' : ' + elem.keiyuchi3Nm : elem.keiyuchiBiko3
        elem.keiyuchi4Disp = elem.keiyuchi4Cd ? elem.keiyuchi4Cd + ' : ' + elem.keiyuchi4Nm : elem.keiyuchiBiko4
        elem.keiyuchi5Disp = elem.keiyuchi5Cd ? elem.keiyuchi5Cd + ' : ' + elem.keiyuchi5Nm : elem.keiyuchiBiko5
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        elem.hacchakuNm = [undefined, null, ''].includes(elem.hatsuchiDisp) && [undefined, null, ''].includes(elem.chakuchiDisp) ? '' : elem.hatsuchiDisp + ' ⇒ ' + elem.chakuchiDisp
        elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiNm : elem.hinmeiBiko
        elem.juchuSuryoDisp = elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : ''
        elem.tankaDisp = elem.tanka ? filter.numericFormatter(elem.tanka) : ''
        elem.juchuJuryoDisp = elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : ''
        elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + 'km' : ''
        elem.yoteiSagyoJikanDisp = elem.yoteiSagyoJikan ? filter.minToIntervalTimeFormatter(elem.yoteiSagyoJikan) : null
        elem.kihonUnchinDisp = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : ''
        elem.hokanKingakuDisp = elem.hokanKingaku ? filter.numericFormatter(elem.hokanKingaku) : ''
        elem.niekiKingakuDisp = elem.niekiKingaku ? filter.numericFormatter(elem.niekiKingaku) : ''
        elem.unchinHokaKingakuDisp = elem.unchinHokaKingaku ? filter.numericFormatter(elem.unchinHokaKingaku) : ''
        elem.hiwayPriceDisp = elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : ''
        elem.unchinHokaHikazeiDisp = elem.unchinHokaHikazei ? filter.numericFormatter(elem.unchinHokaHikazei) : ''
        elem.tatekaekinHikazeiDisp = elem.tatekaekinHikazei ? filter.numericFormatter(elem.tatekaekinHikazei) : ''
        elem.nenryoSurchargeDisp = elem.nenryoSurcharge ? filter.numericFormatter(elem.nenryoSurcharge) : null
        elem.tsumikomiKingakuDisp = elem.tsumikomiKingaku ? filter.numericFormatter(elem.tsumikomiKingaku) : null
        elem.torioroshiKingakuDisp = elem.torioroshiKingaku ? filter.numericFormatter(elem.torioroshiKingaku) : null
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        elem.taikiJikanTankaDisp = elem.taikiJikanTanka ? filter.numericFormatter(elem.taikiJikanTanka) : null
        elem.taikiJikanKingakuDisp = elem.taikiJikanKingaku ? filter.numericFormatter(elem.taikiJikanKingaku) : null
        elem.futaiGyomuKingakuDisp = elem.futaiGyomuKingaku ? filter.numericFormatter(elem.futaiGyomuKingaku) : null
        elem.warimashiTaishoJikanDisp = elem.warimashiTaishoJikan ? filter.minToIntervalTimeFormatter(elem.warimashiTaishoJikan) : null
        elem.warimashiJikanTankaDisp = elem.warimashiJikanTanka ? filter.numericFormatter(elem.warimashiJikanTanka) : ''
        elem.jikanWarimashiKingakuDisp = elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : ''
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) + 'km' : ''
        elem.warimashiKyoriTankaDisp = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.kyoriWarimashiKingakuDisp = elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : ''
        elem.warimashiSonotaKingakuDisp = elem.warimashiSonotaKingsku ? filter.numericFormatter(elem.warimashiSonotaKingsku) : ''
        elem.yoshaKihonUnchinDisp = elem.yoshaKihonUnchin ? filter.numericFormatter(elem.yoshaKihonUnchin) : ''
        elem.yoshaHiwayPriceDisp = elem.yoshaHiwayPrice ? filter.numericFormatter(elem.yoshaHiwayPrice) : ''
        elem.yoshaUnchinHokaKingakuDisp = elem.yoshaUnchinHokaKingaku ? filter.numericFormatter(elem.yoshaUnchinHokaKingaku) : ''
        elem.yoshaUnchinHokaHikazeiDisp = elem.yoshaUnchinHokaHikazei ? filter.numericFormatter(elem.yoshaUnchinHokaHikazei) : ''
        elem.sagyoinTeateKingaku1Disp = elem.sagyoinTeateKingaku1 ? filter.numericFormatter(elem.sagyoinTeateKingaku1) : ''
        elem.sharyoKeihiHiwayEtcDisp = elem.sharyoKeihiHiwayEtc ? filter.numericFormatter(elem.sharyoKeihiHiwayEtc) : ''
        elem.sharyoKeihiHiwayGenkinDisp = elem.sharyoKeihiHiwayGenkin ? filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) : ''
        elem.sharyoKeihiFerryDisp = elem.sharyoKeihiFerry ? filter.numericFormatter(elem.sharyoKeihiFerry) : ''
        elem.sharyoKeihiEtc1Disp = elem.sharyoKeihiEtc1 ? filter.numericFormatter(elem.sharyoKeihiEtc1) : ''
        elem.uriageKingakuDisp = elem.uriageKingaku ? filter.numericFormatter(elem.uriageKingaku) : ''
        return elem
      }).sort((a, b) => {
        if (a.sagyoYoteiYmd > b.sagyoYoteiYmd) { return 1 }
        if (a.sagyoYoteiYmd === b.sagyoYoteiYmd) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.juchuEigyoshoCd > b.juchuEigyoshoCd) { return 1 }
        if (a.juchuEigyoshoCd === b.juchuEigyoshoCd) { return 0 }
        return -1
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isSelectButtonDisabled () {
      return this.selected.length === 0
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.8
      }
      return this.tableHeight * 0.41
    },
    computedDisplayItems () {
      const rows = this.filteredRows || []
      const text = (this.searchText || '').toString().trim()
      const keys = (this.headers || []).map(h => h.value).filter(v => v && v !== 'actions')

      // フリーワード絞り込み（v-data-tableの custom-filter と同等の当て方）
      const filtered = !text
        ? rows
        : rows.filter(row => {
          return keys.some(k => this.filtering(row[k], text, row))
        })

      // ページング
      const per = this.itemsPerPage || 100
      const page = this.page || 1
      const start = (page - 1) * per
      return filtered.slice(start, start + per)
    },
    computedTotalItems () {
      const rows = this.filteredRows || []
      const text = (this.searchText || '').toString().trim()
      const keys = (this.headers || []).map(h => h.value).filter(v => v && v !== 'actions')

      if (!text) return rows.length
      return rows.filter(row => keys.some(k => this.filtering(row[k], text, row))).length
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('DdJuchuRirekiSearchButton.defineHeaderPromise')
            if (self.customHeaders && self.customHeaders.length > 0) {
              self.headers = self.customHeaders
            } else {
              self.headers = [
                { text: '', value: 'actions', align: 'center' },
                { text: '受注営業所', value: 'juchuEigyoshoNm' },
                { text: '荷主', value: 'tokuisakiNm' },
                // { text: '注文番号', value: 'chumonNo' },
                { text: '発地', value: 'hatsuchiDisp' },
                { text: '着地', value: 'chakuchiDisp' },
                { text: '発地年月日', value: 'hatsuchiYmdDisp' },
                { text: '発地時刻', value: 'hatsuchiHmsDisp' },
                { text: '経由地１', value: 'keiyuchi1Disp' },
                { text: '経由地２', value: 'keiyuchi2Disp' },
                { text: '経由地３', value: 'keiyuchi3Disp' },
                { text: '経由地４', value: 'keiyuchi4Disp' },
                { text: '経由地５', value: 'keiyuchi5Disp' },
                { text: '着地', value: 'chakuchiDisp' },
                { text: '着地年月日', value: 'chakuchiYmdDisp' },
                { text: '着地時刻', value: 'chakuchiHmsDisp' },
                { text: '品名', value: 'hinmeiDisp' },
                { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
                { text: '単位', value: 'unitKbnNm' },
                { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
                { text: '単価', value: 'tankaDisp' },
                { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
                { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
                { text: '請求車種', value: 'seikyuShashuSbtNm' },
                { text: '走行距離', value: 'yoteiSokoKyoriDisp', align: 'end' },
                { text: '走行時間', value: 'yoteiSagyoJikanDisp', align: 'center' },
                { text: '運賃', value: 'kihonUnchinDisp', align: 'end' },
                { text: '保管料', value: 'hokanKingakuDisp', align: 'end' },
                { text: '荷役量', value: 'niekiKingakuDisp', align: 'end' },
                { text: '運賃(他)', value: 'unchinHokaKingakuDisp', align: 'end' },
                { text: '運賃(高速)', value: 'hiwayPriceDisp', align: 'end' },
                { text: '運賃他(非)', value: 'unchinHokaHikazeiDisp', align: 'end' },
                { text: '立替金(非)', value: 'tatekaekinHikazeiDisp', align: 'end' },
                { text: '燃料サーチャージ', value: 'nenryoSurchargeDisp', align: 'end' },
                { text: '積込料', value: 'tsumikomiKingakuDisp', align: 'end' },
                { text: '取卸料', value: 'torioroshiKingakuDisp', align: 'end' },
                { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
                { text: '待機時間単価', value: 'taikiJikanTankaDisp', align: 'end' },
                { text: '待機時間料', value: 'taikiJikanKingakuDisp', align: 'end' },
                { text: 'その他付帯業務料', value: 'futaiGyomuKingakuDisp', align: 'end' },
                { text: '割増対象時間', value: 'warimashiTaishoJikanDisp', align: 'end' },
                { text: '割増時間単価', value: 'warimashiJikanTankaDisp', align: 'end' },
                { text: '割増金額(時間)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
                { text: '割増距離', value: 'warimashiTaishoKyoriDisp', align: 'end' },
                { text: '割増単価(距離)', value: 'warimashiKyoriTankaDisp', align: 'end' },
                { text: '割増金額(距離)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
                { text: '割増その他', value: 'warimashiSonotaKingakuDisp', align: 'end' },
                { text: '傭車額', value: 'yoshaKihonUnchinDisp', align: 'end' },
                { text: '傭車通行料', value: 'yoshaHiwayPriceDisp', align: 'end' },
                { text: '運行手当', value: 'sagyoinTeateKingaku1Disp', align: 'end' },
                { text: '高速ETC', value: 'sharyoKeihiHiwayEtcDisp', align: 'end' },
                { text: '高速現金', value: 'sharyoKeihiHiwayGenkinDisp', align: 'end' },
                { text: 'フェリー', value: 'sharyoKeihiFerryDisp', align: 'end' },
                { text: '社内傭車額', value: 'sharyoKeihiEtc1Disp', align: 'end' },
                { text: '請求用備考', value: 'seikyuBiko' },
                { text: '連絡用備考', value: 'renrakuBiko' }
              ]
              if (this.viewStyleType !== 1) {
                this.headers.push({ text: '商品', value: 'hinmeiDisp' })
                this.headers.push({ text: '数量', value: 'juchuSuryoDisp', align: 'end' })
                this.headers.push({ text: '単位', value: 'unitKbnNm' })
                this.headers.push({ text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' })
                this.headers.push({ text: '単価', value: 'tankaDisp', align: 'end' })
              }
              this.headers.push({ text: '請求計上日', value: 'seikyuYoteiYmdDis' })
              if (this.viewStyleType !== 1) {
                this.headers.push({ text: '運賃計算区分', value: 'unchinKeisanKbnNm' })
                this.headers.push({ text: '請求車種', value: 'seikyuShashuSbtNm' })
              }
              this.headers.push({ text: '運賃', value: 'kihonUnchinDisp', align: 'end', width: '100px' })
              if (this.viewStyleType !== 1) {
                this.headers.push({ text: '高速代', value: 'hiwayPriceDisp', align: 'end', width: '100px' })
              } else {
                this.headers.push({ text: '高速代・交通費', value: 'hiwayPriceDisp', align: 'end', width: '100px' })
              }
              this.headers.push({ text: 'その他運賃', value: 'unchinHokaKingakuDisp', align: 'end', width: '100px' })
              this.headers.push({ text: '支払計上日', value: 'shiharaiYoteiYmdDisp' })
              this.headers.push({ text: '傭車運賃', value: 'yoshaKihonUnchinDisp', align: 'end', width: '100px' })
              this.headers.push({ text: '傭車高速代', value: 'yoshaHiwayPriceDisp', align: 'end', width: '100px' })
              if (this.viewStyleType !== 1) {
                this.headers.push({ text: '注文番号', value: 'chumonNo' })
              }
              this.headers.push({ text: '受注No', value: 'juchuNo' })
            }
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          self.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('DdJuchuRirekiSearchButton.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        settingViewScroll: () => {
          return true
        },
        researchPromise: (c) => {
          console.log('DdJuchuRirekiSearchButton.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('DdJuchuRirekiSearchButton.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('DdJuchuRirekiSearchButton.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }

      }
      this.initializeForViewer(opt)
    },
    onRirekiButtonClick: function (e) {
      this.showDialog = true
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e, f)
      this.$emit('selectJuchuRirekiInfo', f.item)
      this.initBindVariables()
      this.showDialog = false
    },
    onRowSelectButtonClick: function (item) {
      console.log('onRowSelectButtonClick', item)
      this.$emit('selectJuchuRirekiInfo', item)
      this.initBindVariables()
      this.showDialog = false
    },

    onSearchButtonClick: function (e) {
      const self = this
      self.selected = []
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd0020/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      self.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.clearInvalidMessage(this.$refs)
        this.initBindVariables()
        this.searchText = ''
        this.rows = []
        this.selected = []
      })
      this.Effects.loadComplete()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.showDialog = false
      console.log('emited', this.showDialog)
      this.initBindVariables()
    },
    searchValidate: function () {
      // 運行予定年月日不整合チェック
      const msg1 = validators.compareDate(this.conditions.sagyoYoteiStartYmdString, this.conditions.sagyoYoteiEndYmdString)
      if (msg1 !== undefined) {
        this.$refs.sagyoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
        this.$refs.sagyoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
        return false
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()

      console.log('initBindVariables', this.paramCondition)

      var wJuchuEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, filter.dateFormatter(d)).id : null
      var wTokuisakiId = null
      var wHatsuchiId = null
      var wChackuchiId = null
      var wMstHinmeiId = null
      if (this.paramCondition) {
        wJuchuEigyoshoId = this.paramCondition.juchuEigyoshoId !== undefined ? this.paramCondition.juchuEigyoshoId : wJuchuEigyoshoId
        wTokuisakiId = this.paramCondition.tokuisakiId !== undefined ? this.paramCondition.tokuisakiId : null
      }
      this.conditions = {
        juchuEigyoshoId: wJuchuEigyoshoId,
        sagyoYoteiStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        sagyoYoteiEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        tokuisakiId: wTokuisakiId,
        chumonNo: '',
        hatsuchiId: wHatsuchiId,
        chakuchiId: wChackuchiId,
        mstHinmeiId: wMstHinmeiId
      }
      this.rows = []
      this.searchText = ''
      this.selected = []
    },

    // ----------------------------------------------------------------------------------------------------
    // ページ遷移
    // ----------------------------------------------------------------------------------------------------
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    getRowKey (row, rowIndex) {
      // itemKey が指定されていて、row にそのプロパティがあればそれを使う
      if (this.itemKey && row && row[this.itemKey] !== undefined && row[this.itemKey] !== null) {
        return row[this.itemKey]
      }
      // 無ければ index
      return rowIndex
    }
  }
}
</script>
